<template>
    <div>
        <input :class="{'hidden':true}" type="file" id="filexls" ref="filexls" v-on:change="handleFileUpload()"
               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        
        <BButton variant="outline-success" @click="loadfromxls">Завантажити з заявки</BButton>
        <a href="/tmp/example.xlsx" target="_blank" class="btn btn-outline-primary waves-effect waves-themed ml-2">
            Шаблон заявки
        </a>
    </div>
</template>

<script>
import {
    BButton,
} from 'bootstrap-vue-next';
export default {
    name: "loadtabxls",
    
    components : {
        BButton
    },
    
    data() {
        return {
            filexls: '',
        }
    },
    
    methods: {
        
        loadfromxls() {
            this.$refs.filexls.click();
        },
        
        handleFileUpload() {
            if (this.$refs.filexls.files.length > 0) {
                this.filexls = this.$refs.filexls.files[0];
                this.sendfile();
            }
        },
        
        async sendfile() {
            let res = new FormData();
            res.append('file', this.filexls);
            
            api.post('/tenders/sales/tenders/helpers/positions/xls', res, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.$emit('setPositions',data.data);
                }
            })
            .catch(err => {
                console.log(err);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
            });
            
        },
        
    }
    
    
}

</script>


